const steps = [
  // {
  //   element: '#sidebar-container',
  //   popover: {
  //     title: '系统菜单',
  //     description: '系统菜单',
  //     nextBtnText: '下一步',
  //     position: 'right-center',
  //   },
  //   padding: 0
  // },
  // {
  //   element: '#breadcrumb-container',
  //   popover: {
  //     title: '当前页面路径',
  //     description: '当前页面路径',
  //     nextBtnText: '下一步',
  //     position: 'bottom-center',
  //   },
  //   padding: 0
  // },
  // {
  //   element: '#loginUser',
  //   popover: {
  //     title: '当前登录用户',
  //     description: '当前登录用户',
  //     nextBtnText: '下一步',
  //     position: 'bottom-right',
  //   },
  //   padding: 0
  // },
  // {
  //   element: '#tags-view-container',
  //   popover: {
  //     title: '多页面栏目',
  //     description: '多页面栏目',
  //     nextBtnText: '下一步',
  //     position: 'bottom-center',
  //   },
  //   padding: 0
  // },
  {
    element: '#changePwd',
    popover: {
      title: '修改密码',
      description: '第一次登录系统需要修改密码',
      showButtons: false,
      position: 'right-center',
    },
    padding: 0
  },
]

export default steps
